import { defineMessages } from 'react-intl';

export default defineMessages({
  remainingQuotaLabel: {
    id: 'remaining',
    description: 'remaining quota label',
    defaultMessage: 'remaining',
  },
  inCartLabel: {
    id: 'summary.inCartLabel',
    description: 'in cart label',
    defaultMessage: 'in cart',
  },
  submittedLabel: {
    id: 'submitted',
    description: 'submitted',
    defaultMessage: 'submitted',
  },
  basePriceLabel: {
    id: 'summary.basePriceLabel',
    description: 'base price label',
    defaultMessage: 'base price',
  },
  currency: {
    id: 'currency',
    description: 'USD',
    defaultMessage: 'USD',
  },
});
